import React from 'react';
import TableCell from '@mui/material/TableCell';
import { TableRow, Button, Avatar } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

function CoachBody({ row, setCoachToEdit }) {
  console.log('row in coach section', row);
  return (
    <>
      <TableRow
        key={row._id}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <TableCell align='left'>
          <Avatar
            alt='Coach Image'
            src={row.coachImageUrl}
            sx={{ width: 24, height: 24 }}
          />
        </TableCell>
        <TableCell align='left'>{row.name} </TableCell>
        <TableCell align='left'> {row.designation} </TableCell>
        <TableCell align='left'> {row.country} </TableCell>
        <TableCell align='left'> {row.areas.join(', ')}</TableCell>

        <TableCell align='center'>
          <Button
            onClick={() => {
              setCoachToEdit(row);
            }}
          >
            <EditIcon sx={{ color: 'primary.main' }} />{' '}
          </Button>
        </TableCell>
      </TableRow>
    </>
  );
}

export default CoachBody;
